import { useParams } from "react-router-dom";
import ChatThreadView from "../components/chat/ChatThreadView";
import useVisualViewportHeight from "../hooks/useVisualViewportHeight";

export default function ChatDetail() {
  const { tid } = useParams();
  // Wave 19 #95/#97/#98 — `useVisualViewportHeight` keeps `--hv-vvh` in
  // sync with the actual visible area so any descendant that wants to
  // pin to the keyboard line can use it. The chat *shell itself* now
  // uses pure flexbox sizing (Layout `<main>` is `flex flex-col` on
  // chat-detail; `page-content` is `flex-1 min-h-0`; this div is
  // `flex-1 min-h-0`) — that's bullet-proof because it doesn't try to
  // compute against a fixed topbar height (which varies with safe-area
  // inset on devices with notches and across OS versions).
  useVisualViewportHeight();
  return (
    <div
      className="flex-1 min-h-0 flex flex-col md:-mx-6 md:-mt-6 md:-mb-6"
      data-testid="chat-detail-shell"
    >
      <ChatThreadView threadId={tid} />
    </div>
  );
}
